import type { FeatureLike } from 'ol/Feature';
import Feature from 'ol/Feature';
import type { Geometry } from 'ol/geom';

import type { GeoJsonStylePropertiesDTO } from '@nora-monorepo/nora-api-client';

/**
 * Typed accessor for OpenLayers feature properties.
 */
export function getFeatureProperties<T extends object>(
  feature: FeatureLike,
): Partial<T> {
  return feature.getProperties() as Partial<T>;
}

/**
 * Typed `instanceof Feature` guard.
 */
export function isFeature<G extends Geometry = Geometry>(
  value: unknown,
): value is Feature<G> {
  return value instanceof Feature;
}

/**
 * Render-only style fields that some draw tools store on features but are not
 * part of `GeoJsonStylePropertiesDTO`. Combine with the DTO via intersection.
 */
export interface RenderStyleProperties {
  textColor?: string;
  iconStrokeColor?: string;
}

/**
 * Convenience: full style property shape covering both API-defined fields and
 * the render-only extras. Callers can extend this further with their own keys.
 */
export type FeatureStyleProperties = GeoJsonStylePropertiesDTO & RenderStyleProperties;
